module.exports = __webpack_public_path__ + "img/de.4e01863a.png";